
import React from "react";

const SitesSEOContent: React.FC = () => {
  return (
    <section className="mb-20" aria-labelledby="seo-content-heading">
      <div className="bg-gradient-to-br from-fabre-lightgreen/20 to-white rounded-3xl shadow-xl border border-fabre-green/20 p-10">
        <h2 id="seo-content-heading" className="text-3xl font-heading font-bold mb-8 text-fabre-gray text-center">
          Pourquoi choisir Groupe Fabre Environnement ?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <div>
            <h3 className="text-xl font-semibold mb-4 text-fabre-green">
              🌱 Expertise environnementale depuis 25 ans
            </h3>
            <p className="text-fabre-darkteal leading-relaxed">
              Leader régional dans la gestion des déchets, nous mettons notre expertise au service 
              de l'économie circulaire. Nos sites de recyclage utilisent les technologies les plus avancées 
              pour maximiser la valorisation de vos déchets.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4 text-fabre-teal">
              🏭 Réseau de proximité
            </h3>
            <p className="text-fabre-darkteal leading-relaxed">
              Avec nos sites répartis stratégiquement, nous garantissons 
              un service de proximité. Chaque centre dispose d'équipements spécialisés et d'une équipe 
              d'experts pour vous accompagner dans vos projets.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4 text-fabre-gold">
              ♻️ Solutions complètes
            </h3>
            <p className="text-fabre-darkteal leading-relaxed">
              De la location de bennes à l'achat de métaux, en passant par la démolition et la valorisation, 
              nous proposons une gamme complète de services adaptés aux particuliers, professionnels et collectivités.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4 text-fabre-darkgreen">
              🏆 Qualité certifiée
            </h3>
            <p className="text-fabre-darkteal leading-relaxed">
              Nos processus sont certifiés et respectent les normes environnementales les plus strictes. 
              Nous nous engageons pour une gestion responsable et durable de vos déchets.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SitesSEOContent;
